import React, { useEffect, useState } from 'react';
import { SagittalHead } from '../consonantTour/SagittalHead';
import { useT } from '../../lib/lessonI18n';

// Tongue body from a vowel position: x = backness (0 front → 100 back), y = openness (0 close → 100 open).
export const tongueFor = ([x, y]) => {
  const px = Math.round(66 + x * 0.48);
  const py = Math.round(89 + y * 0.28);
  return `M58,124 Q58,${py + 20} ${Math.max(px - 18, 62)},${py + 10} Q${px - 8},${py} ${px},${py} Q${px + 14},${py} ${Math.max(px + 20, 120)},${py + 16} Q130,128 128,146`;
};

// Sagittal head posed on a vowel; with `to` it glides from `pos` to `to` (diphthongs), replayed on `replayKey`.
export const VowelHead = ({ pos, to, rounded, toRounded, replayKey = 0, voiced = true, testid = 'vowel-head' }) => {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    setStage(0);
    if (!to) return undefined;
    const tm = setTimeout(() => setStage(1), 650);
    return () => clearTimeout(tm);
  }, [pos, to, replayKey]);
  const cur = stage && to ? to : pos;
  const round = stage && to ? toRounded : rounded;
  return <SagittalHead tongueD={tongueFor(cur)} rounded={!!round} jaw={cur[1] / 100} voiced={voiced} testid={testid} />;
};

// Lips seen from the front: spread vs rounded.
export const LipsFront = ({ rounded }) => {
  const T = useT();
  return (
    <svg viewBox="0 0 80 50" className="w-full h-full" data-testid={`lips-${rounded ? 'rounded' : 'spread'}`} role="img" aria-label={rounded ? T('labbra arrotondate', 'rounded lips') : T('labbra distese', 'spread lips')}>
      <ellipse cx="40" cy="25" rx={rounded ? 13 : 30} ry={rounded ? 12 : 7} fill="#7f1d1d" stroke="#fda4af" strokeWidth="5" style={{ transition: 'rx .5s ease, ry .5s ease' }} />
      <ellipse cx="40" cy="25" rx={rounded ? 6 : 24} ry={rounded ? 6 : 2.5} fill="#0f172a" style={{ transition: 'rx .5s ease, ry .5s ease' }} />
    </svg>
  );
};
